import React from "react";
import { useParams } from "react-router-dom"; // Import du hook useParams
import ReactApexChart from "react-apexcharts";
import formations from "../../../CommonData/Data/formation";

const StepGraphForDetail = () => {
    const { id } = useParams(); // Récupère l'ID du stage depuis l'URL
    const stageId = parseInt(id, 10); // Convertit l'ID en nombre pour correspondre aux données

    // Extraction des données pour le stage correspondant
    const stepsData = formations.flatMap((formation) =>
        formation.stages
            .filter((stage) => stage.id === stageId) // Filtre par stageId
            .flatMap((stage) =>
                stage.steps.map((step) => ({
                    id: step.id,
                    timer: step.timer || 0, // Timer pour les barres (0 si non défini)
                    erreurs: step.erreurs || 0, // Nombre d'erreurs pour la ligne
                }))
            )
    );

    const ids = stepsData.map((step) => step.id); // Axe des X
    const timers = stepsData.map((step) => step.timer); // Axe des Y (barres)
    const erreurs = stepsData.map((step) => step.erreurs); // Axe des Y (ligne)

    // Configuration du graphique
    const chartOptions = {
        chart: {
            height: 350,
            type: "line", // Type principal du graphique
            toolbar: {
                show: true,
            },
        },
        plotOptions: {
            bar: {
                columnWidth: "50%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: [0, 4], // 0 pour les barres, 4 pour la ligne
        },
        xaxis: {
            categories: ids,
            title: {
                text: "IDs des Steps",
            },
        },
        yaxis: [
            {
                title: {
                    text: "Temps (secondes)",
                },
            },
            {
                opposite: true,
                title: {
                    text: "Nombre d'Erreurs",
                },
            },
        ],
        colors: ["#0ab39c", "#ff4560"], // Couleurs : vert pour les barres, rouge pour la ligne
        tooltip: {
            shared: true,
            intersect: false,
        },
    };

    // Séries de données
    const chartSeries = [
        {
            name: "Temps (secondes)",
            type: "bar",
            data: timers,
        },
        {
            name: "Nombre d'Erreurs",
            type: "line",
            data: erreurs,
        },
    ];

    return (
        <div id="chart">
            {stepsData.length > 0 ? (
                <ReactApexChart
                    options={chartOptions}
                    series={chartSeries}
                    type="line"
                    height={350}
                />
            ) : (
                <p>Aucune donnée pour le stage sélectionné.</p>
            )}
        </div>
    );
};

export default StepGraphForDetail;
